const upgrade: any = {
  Title: "We're upgrading your account",
  SubTitle:
    "Emerson Ecologics is getting a fresh new look, making it even easier for you to shop for healthcare's best supplements.",
  Note: "Please avoid refreshing this page while we are getting things ready. It shouldn't take long!",
  Ready: "Your updated account is ready to go!",
  MFA: "Sign in with your updated password and multi-factor authentication.",
  Description: `
      Don't worry—everything you love is still here:<1><0>Your favorite brands and products are all available.</0><1>The tools and workflows you use to shop and discover haven't changed.</1></1>`,
  Success: {
    Subtitle:
      "We'll verify your credentials within 24 hours. <1/> In the meantime, you can continue exploring 400+ brands of healthcare's best supplements.",
  },
} as const;

export { upgrade };
